import React, { useState, useEffect } from 'react';

const RecentActivity = () => {
  const [activities, setActivities] = useState([]);
  const [visibleCount, setVisibleCount] = useState(0);

  const allActivities = [
    {
      id: 1,
      icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M8 17l4 4 4-4" /><path d="M12 12v9" /><path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29" /></svg>,
      title: 'Product uploaded to eBay & Shopify',
      description: 'Vintage Leather Jacket - Size M',
      time: '2 minutes ago',
      status: 'success'
    },
    {
      id: 2,
      icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" /></svg>,
      title: 'Image enhanced successfully',
      description: 'Background removed, quality improved',
      time: '5 minutes ago',
      status: 'success'
    },
    {
      id: 3,
      icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7" /><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" /><path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4" /></svg>,
      title: 'Listing deployed to 5 marketplaces',
      description: 'Nike Air Jordan 1 - Limited Edition',
      time: '12 minutes ago',
      status: 'success'
    },
    {
      id: 4,
      icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" /></svg>,
      title: 'Blurred image detected',
      description: 'Manual review recommended',
      time: '18 minutes ago',
      status: 'warning'
    },
    {
      id: 5,
      icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></svg>,
      title: 'Product sold on Poshmark',
      description: 'Gucci Belt - Authentic',
      time: '25 minutes ago',
      status: 'success'
    },
    {
      id: 6,
      icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M23 4v6h-6" /><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" /></svg>,
      title: 'Inventory sync completed',
      description: 'All platforms updated',
      time: '32 minutes ago',
      status: 'info'
    },
    {
      id: 7,
      icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 3v18h18" /><path d="M18 17V9" /><path d="M13 17V5" /><path d="M8 17v-3" /></svg>,
      title: 'Weekly report generated',
      description: '156 products processed',
      time: '1 hour ago',
      status: 'info'
    }
  ];

  useEffect(() => {
    setActivities(allActivities);

    // Animate activities appearing
    const timer = setInterval(() => {
      setVisibleCount(prev => {
        if (prev < allActivities.length) {
          return prev + 1;
        }
        clearInterval(timer);
        return prev;
      });
    }, 200);

    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="dashboard-card activity-panel-card">
      <div className="card-body">
        <div className="card-header">
          <h3 className="card-title">Recent Activity</h3>
          <p className="card-subtitle">Latest system events</p>
        </div>

        <div className="activity-timeline">
          {activities.slice(0, visibleCount).map((activity, index) => (
            <div
              key={activity.id}
              className={`activity-item ${activity.status}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="activity-icon">{activity.icon}</div>
              <div className="activity-content">
                <div className="activity-title">{activity.title}</div>
                <div className="activity-description">{activity.description}</div>
                <div className="activity-time">{activity.time}</div>
              </div>
              <div className={`activity-status ${activity.status}`}></div>
            </div>
          ))}
        </div>

        <div className="activity-footer">
          <button className="view-all-btn">
            View All Activity
            <span className="btn-arrow">→</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecentActivity;